import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-6">Effective Date: September 1st, 2025</p>

        <p className="mb-4">
          At PoemXtra, we value your privacy and are committed to protecting your personal information. 
          This Privacy Policy explains how we collect, use, and safeguard the data you share with us when you visit or interact with our website.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Personal Information (e.g., name, email address).</li>
          <li>Usage Data (e.g., IP address, browser type, pages visited, time spent).</li>
          <li>Cookies and Tracking Technologies to improve user experience.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Provide access to PoemXtra services.</li>
          <li>Personalize user experience.</li>
          <li>Send updates, newsletters, or promotions (if opted in).</li>
          <li>Analyze performance and improve functionality.</li>
          <li>Ensure security and prevent misuse.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Sharing of Information</h2>
        <p className="mb-4">
          We do not sell, rent, or trade your personal data. We may share it with service providers (for operations) 
          or legal authorities if required by law.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Cookies & Tracking</h2>
        <p className="mb-4">
          PoemXtra uses cookies to remember preferences, improve site performance, and analyze traffic. 
          You can disable cookies in browser settings, but some features may not work properly.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Access, update, or delete your personal info.</li>
          <li>Opt out of newsletters or emails.</li>
          <li>Restrict or object to data processing.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Third-Party Links</h2>
        <p className="mb-4">
          Our site may link to external websites. We are not responsible for their privacy practices.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Changes to Policy</h2>
        <p className="mb-4">
          Updates will be posted here with a new effective date.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact Us</h2>
        <p>If you have any questions, email us at <strong>poemxtra@gmail.com</strong>.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
